import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { OpenGgCdnService } from 'src/app/apis/open-gg-cdn.service';
import { getWebConfig, IWebConfig } from 'src/app/app-web';
import { AuthenticationService, TokenUser } from 'src/app/services/authentication.service';
import { IframeOpenImageData } from 'src/app/utils/constants/iframe-open-image-data';
import { UserRolesType } from 'src/app/utils/constants/user-roles';
import { DataFromIFrame, OpenImage } from 'src/app/utils/interfaces/open-image';

@Component({
  selector: 'app-select-gg-cdn-image',
  templateUrl: './select-gg-cdn-image.component.html',
  styleUrls: ['./select-gg-cdn-image.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectGgCdnImageComponent),
      multi: true,
    },
  ],
})
export class SelectGgCdnImageComponent implements ControlValueAccessor, OnInit {
  @Input() iFrameOpenImageData: IframeOpenImageData | undefined;

  constructor(private svAuth: AuthenticationService, private domSanitizer: DomSanitizer) {}

  config: IWebConfig = getWebConfig();

  currentUser: TokenUser = this.svAuth.getUser;

  isSuperAdmin = (['Superadmin'] as UserRolesType[]).some((role) =>
    this.currentUser?.Role?.some((ur) => ur === role)
  );
  isAdmin = (['Admin'] as UserRolesType[]).some((role) =>
    this.currentUser?.Role?.some((ur) => ur === role)
  );

  // https://dash.cdncore-files.online/ | http://localhost:4299
  iFrameOrigin = 'https://dash.cdncore-files.online';
  iFramePath = '/open-pages/images';
  safeUrlIFrame: SafeUrl | undefined;
  initIFrame() {
    const theme = localStorage.getItem('theme');
    // let iframeOpenImageStorage = localStorage.getItem('iframe-open-image');
    // if (this.Config.Production === false) {
    //   if (!iframeOpenImageStorage) {
    //     localStorage.setItem('iframe-open-image', '');
    //   }
    //   this.iFrameOrigin = iframeOpenImageStorage || 'http://localhost:4299';
    // } else {
    //   localStorage.removeItem('iframe-open-image');
    // }
    const tags = this.iFrameOpenImageData?.tags
      .map((tag) => tag.replace('{website}', this.config.YourBand.en))
      .join(',');

    const fullUrl = `${this.iFrameOrigin}${this.iFramePath}?theme=${theme}&tags=${tags}`;
    this.safeUrlIFrame = this.domSanitizer.bypassSecurityTrustResourceUrl(fullUrl);

    window.addEventListener('message', (event) => {
      // if (this.fileType !== 'url') {
      //   return;
      // }

      if (event.origin === this.iFrameOrigin) {
        const data = event.data as DataFromIFrame<OpenImage>;
        if (data.name === 'event-select-image') {
          this.onChange(data.value.public_link);
          console.log(`🚀 ~ this.imageLink:`, this.imageLink);
          this.onTouched();
        }
      }
    });
  }

  ngOnInit(): void {
    console.log(`🚀 ~ this.iFrameOpenImageData:`, this.iFrameOpenImageData);
    if ((this.isSuperAdmin || this.isAdmin) && this.iFrameOpenImageData) {
      this.initIFrame();
    }
  }

  imageLink: string = '';
  writeValue(obj: any): void {
    this.imageLink = obj;
  }
  private onTouched: any = () => {};
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  private onChange: any = () => {};
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  setDisabledState(isDisabled: boolean): void {}

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement> | undefined;
  @Input() newFile: File | null = null;
  @Output() newFileChange = new EventEmitter<File | null>();
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) {
      return;
    }

    this.newFile = file;
    this.newFileChange.emit(this.newFile);
  }

  clearSelectFile() {
    this.fileInput!.nativeElement.value = '';
    this.newFile = null;
    this.newFileChange.emit(this.newFile);
  }
}
